import React, { useState, useEffect } from 'react';
import PageHeader from '../../../../components/PageHeader/PageHeader';
import { API } from '../../../../API/API';
import GridDefaultShimmer from '../../../../components/GridDefaultShimmer/GridDefaultShimmer';
import { Color, constData } from '../../../../const/Const';
import UserNew from './UserNew';
import Can from '../../../../components/Can/Can';

const UserList = (props) => {

    const [columns] = useState([{
        name: 'Нэвтрэх нэр',
        fieldName: 'userid',
        colSize: 'small',
        onRender: (item) => {
            return (
                <div style={{ color: Color.blue, cursor: 'pointer' }} onClick={() => onPressUser(item.userid)}>{item.userid}</div>
            );
        },
    }, {
        name: 'И-мэйл',
        fieldName: 'email',
        colSize: 'mid'
    }, {
        name: 'Ажилтны нэр',
        fieldName: 'fullname',
        colSize: 'mid'
    }, {
        name: 'Үүрэг',
        fieldName: 'rolename'
    }, {
        name: 'Мэдээлэл',
        fieldName: 'datafilter'
    }, {
        name: 'Лиценз',
        fieldName: 'licensename'
    }, {
        name: 'Төлөв',
        fieldName: 'status',
        onRender: (item) => (
            <div>{filterData.find(a => a.key === item.status)?.text}</div>
        )
    }]);

    const [filterValue, setFilterValue] = useState('All');
    const [filterData] = useState(constData.User_Status_Filter.concat(constData.User_Status));
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);

    const [showNew, setShowNew] = useState(false);
    const [userid, setUserId] = useState();

    const getData = async () => {
        let tData = [];
        try {
            setLoading(true);
            await API.get('/api/shared/user-management/user/list?status=' + filterValue).then(response => {
                if (response.status === 200 && response.data.rettype === 0) {
                    if (response.data.retdata) {
                        tData = response.data.retdata;
                    }
                }
            });
        } finally {
            setLoading(false);
        }
        setData(tData);
        setOData(tData);
    }

    useEffect(() => {
        getData();
    }, [filterValue]);

    const afterSave = (p_close) => {
        if (p_close) {
            setShowNew(false);
        }
        getData();
    }

    const onChangeFilter = (p_key, p_name) => {
        setFilterValue(p_key);
    }

    const onPressNew = () => {
        setUserId();
        setShowNew(true);
    }

    const onDismiss = () => {
        setUserId();
        setShowNew(false);
    }

    const onPressUser = (p_userid) => {
        setUserId(p_userid);
        setShowNew(true);
    }

    const onSearch = (p_data) => {
        setData(p_data);
    }

    return (
        <div>
            <PageHeader
                showLeftFilter
                changeFilter={onChangeFilter}
                filterValue={filterValue}
                filterData={filterData}
                buttonTitle="Хэрэглэгч нэмэх"
                dataCount={data?.length}
                onButtonClick={onPressNew}
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
                loading={loading}
            />
            <GridDefaultShimmer
                setKey="row_index"
                loading={loading}
                columns={columns}
                data={data}
            />
            <UserNew isOpen={showNew} afterSave={afterSave} onDismiss={onDismiss} userid={userid} />
        </div>
    );
}

export default UserList;